import { StepNav } from 'slab'

import { type Step } from '../types'
import { getStepsFromData, type StepConfig } from './Navigation'

export function CompletedOnboardingSidebar ({
  isThisEnrollmentForRenewal,
}: {
  isThisEnrollmentForRenewal: boolean;
}) {
  let steps: Array<StepConfig> = []
  if (isThisEnrollmentForRenewal) {
    steps = [
      { stepName: 'renewal_confirm_info' as Step, stepLabel: 'Personal details' },
      { stepName: 'renewal_show_summary' as Step, stepLabel: 'Budget and plan changes' },
      { stepName: 'medical_plan' as Step, stepLabel: 'Your insurance' },
      { stepName: 'renewal_confirm_enrollment' as Step, stepLabel: 'Confirm and enroll' },
    ]
  } else {
    steps = getStepsFromData(null).filter(Boolean) as Array<StepConfig>
  }

  const finalStepName = isThisEnrollmentForRenewal
    ? 'renewal_confirm_enrollment'
    : 'finalize_enrollment'

  return (
    <StepNav>
      {steps.map(({ stepName, stepLabel }, idx) => (
        <StepNav.Step
          key={stepName as string}
          active={stepName === finalStepName}
          available={false}
          complete={idx !== steps.length - 1}
          name={stepLabel}
        />
      ))}
    </StepNav>
  )
}
